import Rows from "../../../library/components/layout/Rows";
import Columns from "../../../library/components/layout/Columns";
import { PDF_ANNOTATION_COLOR_GROUPS } from "./pdfCanvasConstants";
import { getPdfCanvasPanelBaslikStyle, getPdfCanvasPanelGrupStyle } from "./pdfCanvasPanelStyles";

interface IPdfColorLegendPanelProps {
    isWideLayout: boolean,
}

const PdfColorLegendPanel = (props: IPdfColorLegendPanelProps) => {
    const panelBaslikStyle = getPdfCanvasPanelBaslikStyle(props.isWideLayout);
    const panelGrupStyle = getPdfCanvasPanelGrupStyle();

    if (props.isWideLayout) {
        return <Rows gap={4} p={8} style={panelGrupStyle}>
            <span style={panelBaslikStyle}>Renklendirme</span>
            <Rows gap={6} style={{ flexShrink: 0 }}>
                {PDF_ANNOTATION_COLOR_GROUPS.map(group =>
                    <Rows key={`legend_${group.groupName}`} gap={2}>
                        <span style={{ fontWeight: 600, fontSize: "0.78rem" }}>{group.groupName}</span>
                        {group.items.map(item =>
                            <Columns key={`legend_item_${item.color}`} gap={4} style={{ alignItems: "center" }}>
                                <span style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    border: "1px solid #999",
                                    background: item.color,
                                    display: "inline-block",
                                    flexShrink: 0,
                                }} />
                                <span style={{ fontSize: "0.72rem", lineHeight: 1.2 }}>{item.label}</span>
                            </Columns>
                        )}
                    </Rows>
                )}
            </Rows>
        </Rows>;
    }

    return <Rows gap={4} p={8} style={panelGrupStyle}>
        <span style={panelBaslikStyle}>Renklendirme</span>
        <Columns gap={14} style={{ alignItems: "center", flexWrap: "wrap" }}>
            {PDF_ANNOTATION_COLOR_GROUPS.map(group =>
                <Columns key={`legend_${group.groupName}`} gap={8} mr={8} style={{ alignItems: "center" }}>
                    <span style={{ fontWeight: 600, fontSize: "0.85rem" }}>{group.groupName}:</span>
                    {group.items.map(item =>
                        <Columns key={`legend_item_${item.color}`} gap={4} style={{ alignItems: "center" }}>
                            <span style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                border: "1px solid #999",
                                background: item.color,
                                display: "inline-block",
                            }} />
                            <span style={{ fontSize: "0.82rem" }}>{item.label}</span>
                        </Columns>
                    )}
                </Columns>
            )}
        </Columns>
    </Rows>;
};

export default PdfColorLegendPanel;
